import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import { Lightbulb, MailSentIcon } from "@/assets/icons";
import { defaultDateFormat } from "@/core/date";
import { sanitizeHtml } from "@/core/security";
import { useNavigation } from "@/shared/hooks";

import { RegisterSteps } from "../../../Register/utils";
import { StyledConfirmationContainer, StyledEmail, StyledIndications } from "../../../styled";
import { StyledFindEmail, StyledTipBoxContainer } from "./styled";

type InviteCheckEmailProps = {
    date?: Date;
    email?: string;
    officeId?: string;
};

const InviteCheckEmail: FC<InviteCheckEmailProps> = ({ date = null, email, officeId }) => {
    const { t } = useTranslation();
    const { navToRegisterState } = useNavigation();

    function handleRegisterManually() {
        navToRegisterState(email, officeId, RegisterSteps.COMPLETE_PROFILE);
    }

    return (
        <>
            <div className="title">{t("Registration.Confirmation.Title")}</div>
            <StyledConfirmationContainer>
                <MailSentIcon />
                <StyledIndications style={{ margin: 0 }}>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(t("Registration.Confirmation.AlreadyRegistered")),
                        }}
                    />
                </StyledIndications>
                <StyledEmail>{email}</StyledEmail>

                <StyledIndications style={{ marginTop: 0 }}>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(
                                t("Registration.Confirmation.InviteMessage", {
                                    date: defaultDateFormat(date),
                                }),
                            ),
                        }}
                    />
                </StyledIndications>
            </StyledConfirmationContainer>
            <StyledTipBoxContainer>
                <div className="light-bulb-container">
                    <Lightbulb />
                </div>
                <div className="tip-box">
                    <p className="tip">{t("Registration.Confirmation.Tip")}</p>
                    <p className="inbox-search">{t("Registration.Confirmation.InboxSearch")}</p>
                </div>
            </StyledTipBoxContainer>
            <div className="form-bottom-container end">
                <StyledFindEmail>{t("Registration.Confirmation.FindEmail")}</StyledFindEmail>
                <Button
                    variant="text"
                    data-testid="button-register_manually"
                    style={{ margin: "0 auto", display: "block" }}
                    onClick={handleRegisterManually}
                >
                    {t("Registration.Confirmation.RegisterManually")}
                </Button>
            </div>
        </>
    );
};

export default InviteCheckEmail;
